import React, { useEffect } from "react";
import AROMInitialModal from "./arom-initial-modal";
import AromAssessmentHandOrientationModal from "./arom-assessment-hand-orientation";
import {
  AROM_ASSESSMENT,
  FUNCTIONAL_REACH_ASSESSMENT,
} from "../../models/Enums";
import AromAssessmentGifModal from "./arom-assessment-gif";

interface Props {
  modalNum: number;
}

const CTSIBModals: React.FC<Props> = ({ modalNum }) => {
  const [phase, setPhase] = React.useState(sessionStorage.getItem("phaseNo"));
  const [subAssessment, setSubAssessment] = React.useState(
    sessionStorage.getItem("mCTSIBAssessmentIndex")
  );

  useEffect(() => {
    setPhase(sessionStorage.getItem("phaseNo"));
    setSubAssessment(sessionStorage.getItem("mCTSIBAssessmentIndex"));
  }, [modalNum]);

  return (
    <div>
      {modalNum === 1 && (
        <AROMInitialModal
          phaseNo={phase as string}
          subAssessment={subAssessment as string}
        />
      )}
      {modalNum === 2 && (
        <AromAssessmentHandOrientationModal
          assessment={
            sessionStorage.getItem("selectedAssesment") === "55"
              ? (sessionStorage.getItem(
                  "aromAssessmentIndex"
                ) as AROM_ASSESSMENT)
              : (sessionStorage.getItem(
                  "functionalReachAssessmentIndex"
                ) as FUNCTIONAL_REACH_ASSESSMENT)
          }
        />
      )}
      {modalNum === 3 && (
        <AromAssessmentGifModal
          assessment={
            sessionStorage.getItem("selectedAssesment") === "55"
              ? (sessionStorage.getItem(
                  "aromAssessmentIndex"
                ) as AROM_ASSESSMENT)
              : (sessionStorage.getItem(
                  "functionalReachAssessmentIndex"
                ) as FUNCTIONAL_REACH_ASSESSMENT)
          }
        />
      )}
    </div>
  );
};

export default CTSIBModals;
